var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconUpArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow_up_a{fill:#fff;fill-rule:evenodd;}.arrow_up_b{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrow_up_a",
    d: "M.357,11.718l9.736,9.958,1.722-1.76L4.072,12H23.629V9.677H4.072L11.814,1.76,10.092,0,.357,9.958A1.264,1.264,0,0,0,.357,11.718Zm2.6-.9-.015.016.015.016Z",
    transform: "translate(26.676 4) rotate(90)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "arrow_up_b",
    width: 32,
    height: 32
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconUpArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_up_arrow.71e60416f4a5ae26a1d3fd004fda6f64.svg";